import { Component } from '@angular/core';

@Component({
  selector: 'fast-ui-user-avatar-mock',
  templateUrl: './user-avatar.component.mock.html',
  styleUrls: ['../user-avatar.component.scss', './user-avatar.component.mock.scss'],
})
export class UserAvatarMockComponent {
}
